export const PaymentMethod = {
    ONLINE: 'ONLINE',
    HOME: 'HOME',
}